import http from 'services/http';

export type LeaderboardExam = 'IELTS' | 'SAT';

export interface LeaderboardEntry {
  rank: number;
  /** First name and initial, e.g. "Aziza K.". */
  name: string;
  tests: number;
  bestScore: number | null;
  isMe: boolean;
}

export interface Leaderboard {
  exam: LeaderboardExam;
  weekStart: string;
  entries: LeaderboardEntry[];
  me: { rank: number | null; tests: number; bestScore: number | null } | null;
  hidden: boolean;
}

export async function getLeaderboard(exam: LeaderboardExam, signal?: AbortSignal): Promise<Leaderboard> {
  const { data } = await http.request.get<{ data: Leaderboard }>('/api/portal/leaderboard', { params: { exam }, signal });
  return data.data;
}

export async function setLeaderboardHidden(hidden: boolean): Promise<void> {
  await http.request.put('/api/portal/leaderboard/visibility', { hidden });
}
